import { createSelector } from '@ngrx/store';
import { IAuthState, IRemoteXPACPortalState } from '../../utils/interfaces/store.interfaces';

export const selectAuth = (state: IRemoteXPACPortalState) => state.auth;

export const selectAccessToken = createSelector(
  selectAuth,
  (state: IAuthState) => state.accessToken
);

export const selectUserData = createSelector(
  selectAuth,
  (state: IAuthState) => state.userData
);
